<template>
  <div class="list">
    <div class="flex">
      <div>
        <form-title>课程章节</form-title>
      </div>
      <el-button
        type="primary"
        @click="addChapter(-1)"
      >
        新增章节
      </el-button>
    </div>
    <info-panel>
      <el-tree
        :data="chapterList"
        :props="treeProps"
        :default-expanded-keys="Array.from(expandedKeys)"
        :expand-on-click-node="true"
        node-key="id"
        @node-expand="expand"
        @node-collapse="collapse"
      >
        <span
          slot-scope="{ node, data }"
          class="custom-tree-node"
        >
          <span class="name">{{ data.chapterName }}</span>
          <span class="line" />
          <span class="more">
            <svg-icon
              v-if="data.pid === -1"
              name="union"
              @click.native.stop="addChapter(data.id)"
            />
            <span
              v-if="data.videoUrl && data.pid !== -1"
              class="video-size"
              @click.stop="playVideo(data)"
            >
              <span class="size">
                {{ data.videoSizeMb }}  Mb
              </span>
              <svg-icon
                name="play"
              />
            </span>
            <el-dropdown
              trigger="click"
              @click.native.stop="openDropDown(data)"
            >
              <span class="el-dropdown-link">
                <svg-icon
                  name="more"
                />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="openDialog()">编辑</el-dropdown-item>
                <el-dropdown-item @click.native="deleteChapter()">删除</el-dropdown-item>
                <el-dropdown-item @click.native="moveChapter(1)">上移</el-dropdown-item>
                <el-dropdown-item @click.native="moveChapter(-1)">下移</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </span>
      </el-tree>
    </info-panel>
    <course-chapter-dialog
      :dialog-visible.sync="dialogVisible"
      :item="activeChapterItem"
      @confirm="$emit('listChapter')"
      @close="()=> activeChapterItem = {}"
    />
    <video-dialog
      :dialog-visible.sync="vedioVisible"
      :item="activeVideoItem"
    />
  </div>
</template>

<script>
import courseChapterDialog from '@/components/common/courseChapterDialog.vue';
import infoPanel from '@/components/common/infoPanel.vue';
import formTitle from '@/components/common/formTitle.vue';
import axClient from '@/services';
import videoDialog from '@/components/common/videoDialog.vue';

export default {
  name: 'Chapter',
  components: {
    courseChapterDialog,
    infoPanel,
    formTitle,
    videoDialog,
  },
  props: {
    chapterList: {
      type: Array,
      default: () => [],
    },
    id: {
      type: Number,
    },
  },
  data() {
    return {
      vedioVisible: false,
      activeVideoItem: {},
      dialogVisible: false,
      activeChapterItem: null,
      treeProps: {
        children: 'sonList',
        label: 'chapterName',
      },
      expandedKeys: new Set(),
    };
  },
  methods: {
    // tree expand
    expand(data) {
      this.expandedKeys.add(data.id);
    },
    // tree expand
    collapse(data) {
      this.expandedKeys.delete(data.id);
    },
    // 新增一级章节
    async addChapter(pid) {
      let form = {};
      form = {
        chapterName: '章节名称',
        videoUrl: '',
        courseId: this.id,
        isIncludeVideoExam: 0,
        pid,
      };
      if (pid !== -1) {
        this.expandedKeys.add(pid);
      }
      const data = await axClient.course.upsertChapter(form);
      if (data) {
        this.$message.success('新增章节成功');
        this.$emit('listChapter');
      }
    },
    // 打开下拉章节菜单
    openDropDown(data) {
      this.activeChapterItem = data;
    },
    // 删除章节
    async deleteChapter() {
      const data = await axClient.course.deleteChapter({ id: this.activeChapterItem.id });
      if (data) {
        this.$message.success('删除章节成功');
        this.$emit('listChapter');
      }
    },
    // 移动章节
    async  moveChapter(num) {
      // num 1 上移 -1 下移
      let data = [];
      this.chapterList.forEach((item) => {
        if (item.id === this.activeChapterItem.id) {
          data = this.chapterList;
        } else if (item.sonList) {
          item.sonList.forEach((son) => {
            if (son.id === this.activeChapterItem.id) {
              data = item.sonList;
            }
          });
        }
      });
      const arrIds = data.map((v) => v.id);
      const index = arrIds.indexOf(this.activeChapterItem.id);
      const form = {
        id1: arrIds[index],
        id2: arrIds[index - num],
      };
      const res = await axClient.course.changeChapterRank(form);
      if (res) {
        this.$message.success(`${num === 1 ? '上移' : '下移'}成功`);
        this.$emit('listChapter');
      }
    },
    // 打开编辑弹窗
    openDialog() {
      this.dialogVisible = true;
    },
    // 播放视频
    playVideo(data) {
      this.vedioVisible = true;
      this.activeVideoItem.url = data.videoUrl;
      this.activeVideoItem.title = data.chapterName;
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  .custom-tree-node {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    font-size: 0;
    .name {
      font-size: 16px;
    }
    .more {
      display: flex;
      align-items: center;
    }
    .video-size {
      margin: 10px;
      display: flex;
      align-items: center;
      .size {
        font-size: 14px;
        color: rgba($--base-color-main, 1);
      }
    }
    svg {
      width: 14px;
      height: 18px;
      color: rgba($--base-color-black, 0.3);
      margin-left: 15px;
      &:hover {
        color: rgba($--base-color-main, 1);
      }
    }
    .line {
      flex: 1;
      height: 1px;
      margin-left: 12px;
      background: rgba($--base-color-black, 0.2);
    }
  }
  ::v-deep .el-tree-node__expand-icon {
    font-size: 18px;
  }
}

</style>
